module.exports = __webpack_public_path__ + "static/media/VladmirsOffering.6b9ee296.png";